import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router';
import Helmet from 'react-helmet';

import styled from 'styled-components/macro';
import { loadCover } from 'src/client/redux/modules/gallery';
import head from 'src/client/utils/head';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import urls from 'src/shared/urls';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';

const Div = styled.div`
  & .newsletter form input[type='email'] {
    @media (min-width: 992px) and (max-width: 1199px) {
      width: 169px;
    }
  }
  position: relative;
  top: 0;
  width: 100%;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 30px;

  & .cover-image {
    @media (max-width: 525px) {
      width: 100%;
    }
  }
`;

export default function Cover({
  className = '',
}: {
  // eslint-disable-next-line react/require-default-props
  className?: string;
}) {
  const dispatch = useDispatch();
  const { galleryUUID } = useParams<{ galleryUUID: string }>();
  const history = useHistory();

  const { contentCdnUrl, cdnUrl, config } = useSelector((state) => state.app);
  const site = useSelector((state) => state.site);
  const user = useSelector((state) => state.auth.user);
  const { cover, coverError } = useSelector((state) => state.gallery);

  const [joinUrl] = useJoinUrl({ campaign: 'gallery-cover' });

  useEffect(() => {
    dispatch(loadCover(galleryUUID));
  }, [dispatch, galleryUUID]);

  useEffect(() => {
    if (coverError?.status === 404) {
      history.replace(urls.get.notFound);
    }
  }, [coverError?.status, history]);

  if (cover) {
    return (
      <Div>
        <Helmet {...head(config, site, cdnUrl)}>
          <title>{`${site.name} - ${cover.name}`}</title>
          <meta property="og:title" content={`${site.name} - ${cover.name}`} />
          <meta property="og:url" content={`https://www.${site.domain}/cover/${cover.UUID}`} />
        </Helmet>
        <div className={className}>
          <a {...(!user ? { href: joinUrl } : {})}>
            <img className="cover-image" src={`${contentCdnUrl}/${site.UUID}/${cover.coverImagePath}`} alt="" />
          </a>
        </div>
      </Div>
    );
  }
  return <span />;
}
